import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBaseFormStore } from '../form-base-form/form-base-form.store';
import { FormBaseFormComponent } from '../form-base-form/form-base-form.component';
import { FormSetEnum } from '../../../../../../../../../types/src/services/enum/form-set.enum';
import { FormsMapValueToText } from '@libs/shared/form-helpers/forms/forms-map-value-to-text';
import { ppsKeys, ppsKeysExtra } from '@libs/shared/form-helpers/forms/forms-json-keys';
import { TranslatePipe } from '@ngx-translate/core';
import { SelectInputComponent } from '../../../../../../components/kit/input/select-input/select-input.component';
import {
    TextAreaInputComponent,
} from '../../../../../../components/kit/input/text-area-input/text-area-input.component';
import { FormatPersonPipe } from '../../../../../shared/pipes/format-person.pipe';
import { DateInputComponent } from '../../../../../../components/kit/input/date-input/date-input.component';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';

@Component({
    selector: 'app-form-pps-form',
    templateUrl: './form-pps-form.component.html',
    styleUrls: ['../form-base-form/form-base-form.scss'],
    providers: [FormBaseFormStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslatePipe,
        SelectInputComponent,
        TextAreaInputComponent,
        FormatPersonPipe,
        DateInputComponent,
        ActionButtonsComponent,
    ],
})
export class FormPpsFormComponent extends FormBaseFormComponent implements OnInit {
    values: { [key: string]: string } = {};

    constructor() {
        super();

        this.formUniqueIdentifier = FormSetEnum.PPS;
        this.keys = ppsKeys;

        this.generateForm([
            { name: 'ppsValue', defaultValue: 100, required: false },
            { name: 'note', defaultValue: null, required: false },
        ]);

        for (let i = 100; i >= 0; i -= 10) this.options.push({ value: i, name: i.toString() });

        this.subs.push(
            this.form.valueChanges.subscribe((newValues: any) => {
                this.generateFinalEvaluation(newValues);
            }),
        );
    }

    override ngOnInit() {
        super.ngOnInit();
        if (!this.folderFormData) {
            this.generateFinalEvaluation({});
        }
    }

    protected override generateFinalEvaluation(newValues: any) {
        super.generateFinalEvaluation(newValues);

        this.values = {};
        ppsKeysExtra.forEach((key) => {
            this.values[key] = FormsMapValueToText.mapPpsValueToText(this.totalPoints, key);
        });
    }

    protected readonly ppsKeysExtra = ppsKeysExtra;
}
